import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/yimo-img/endPageLogo.png'
import _imports_1 from '../../assets/img/yimo-img/leftHalfOval.png'
import _imports_2 from '../../assets/img/yimo-img/leftOval.png'
import _imports_3 from '../../assets/img/yimo-img/leftOval2.png'
import _imports_4 from '../../assets/img/yimo-img/rightHalfOval.png'
import _imports_5 from '../../assets/img/yimo-img/rightOval.png'
import _imports_6 from '../../assets/img/yimo-img/rightOval2.png'
import _imports_7 from '../../assets/img/yimo-img/logoMain.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4453f606"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "endPage",
  ref: "endPageRef"
}
const _hoisted_2 = { class: "coverscoll" }
const _hoisted_3 = { class: "srcolltop" }
const _hoisted_4 = { class: "box1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bigLogo",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<img class=\"leftHalfOval\" src=\"" + _imports_1 + "\" alt=\"\" data-v-4453f606><img class=\"leftOval\" src=\"" + _imports_2 + "\" alt=\"\" data-v-4453f606><img class=\"leftOval2\" src=\"" + _imports_3 + "\" alt=\"\" data-v-4453f606><img class=\"rightHalfOval\" src=\"" + _imports_4 + "\" alt=\"\" data-v-4453f606><img class=\"rightOval\" src=\"" + _imports_5 + "\" alt=\"\" data-v-4453f606><img class=\"rightOval2\" src=\"" + _imports_6 + "\" alt=\"\" data-v-4453f606>", 6)
const _hoisted_12 = [
  _hoisted_6
]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"scrollbottom\" data-v-4453f606><div class=\"footer\" data-v-4453f606><div class=\"main\" data-v-4453f606><div class=\"logocontent\" data-v-4453f606><div class=\"footer-logo\" data-v-4453f606><img src=\"" + _imports_7 + "\" alt=\"\" data-v-4453f606></div></div><div class=\"msg\" data-v-4453f606><div class=\"leftmsg\" data-v-4453f606><p data-v-4453f606>广西享玩网络科技有限公司</p><p data-v-4453f606>Guangxi Xiangwan Network Technology Co., Ltd.</p><a class=\"beian\" href=\"https://beian.miit.gov.cn/\" data-v-4453f606><p data-v-4453f606>桂ICP备2022003376号</p></a></div><div class=\"rightmsg\" data-v-4453f606><p data-v-4453f606>联系邮箱：gxxwan8@ sina.com</p><p data-v-4453f606>联系电话：(+86)185 8847 4344</p><p data-v-4453f606> 地址：中国(广西)自由贸易试验区南宁片区庆林路16号天誉花园4号地块5号楼三层3597号 </p></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_download_btn = _resolveComponent("download-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_download_btn, {
            class: _normalizeClass({ animate__animated: _ctx.nowPage === 6, animate__fadeInUp: _ctx.nowPage === 6 })
          }, null, 8, ["class"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["oval animate__slow", { animate__animated: _ctx.nowPage === 6, animate__fadeIn: _ctx.nowPage === 6 }])
        }, _hoisted_12, 2),
        _hoisted_13
      ])
    ])
  ], 512))
}